<template>
    <!-- <div class="modalDialog is-active" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="closeBox"> -->
    <div class="overlay"></div>
    <div class="reviewBox">
        <div>
            <a title="Close" class="close" @click="closeBox">X</a>
            <h4>Assigned Projects {{ this.assignment && this.assignment.employee ? `for ${this.assignment.employee}` : '' }}</h4>
            <hr />
        </div>
        <ag-grid
            :name="title"
            :ref="reference"
            :iteration="iteration"
            :width="width"
            :height="height"
            :columns="columnDefs"
            :row-data="rowData"
            :options="gridOptions"
            sidebar="filters"
            :filter-order="filterOrder"
            :classes="'ag-theme-balham ' + (loading ? 'opacity-25' : '')"
        />
        <div>
            <assignment-override
                v-if="showAssignmentOverrideBox"
                @save="saveAssignmentOverride"
                :assignment="assignment"
                :override="currentOverride"
                :enable-pro-books="enableProBooks"
                :showProjects="showProjects"
                :showAssignedProjects="showAssignedProjects"
                :isTerminated="isTerminated"
                @close="showAssignmentOverrideBox=false"
            />
        </div>
        <div class="right">
            <span v-if="buttonNo">
                <button class="btn btn-default m-right-10" @click="closeBox"><span v-if="buttonNoLabel">{{buttonNoLabel}}</span><span v-else>Close</span></button>
            </span>
            <span v-if="buttonYes">
                <button class="btn btn-primary" @click="addAssignmentOverride" :disabled="isTerminated"><span v-if="buttonYesLabel">{{buttonYesLabel}}</span><span v-else>Add Override</span></button>
            </span>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import 'regenerator-runtime/runtime';
import Axios from '../classes/Axios.js';
import DateField from './DateField.vue';
import AgGrid from './AgGrid.vue';
import {defineComponent, ref} from 'vue';
import oasisModal from './oasis-modal.vue';
import PollingMixin from '../mixins/PollingMixin.js';
import AssignmentOverride from './AssignmentOverride.vue';

export default defineComponent ({
    name: "AssigmentOverridesList",

    mixins: [PollingMixin],

    emits: ['close', 'save'],

    components: {
        'ag-grid': AgGrid,
        'oasis-modal': oasisModal,
        'assignment-override': AssignmentOverride,
    },

    props: {
        title: {
            type: String,
            default: 'Assigned Projects',
            required: false
        },
        assignment: {
            type: Object,
            required: false,
        },
        enableProBooks: {
            type: Boolean,
            required: false,
            default: false,
        },
        showProjects: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAssignedProjects: {
            type: Boolean,
            required: false,
            default: false,
        },
        adminAccess: {
            type: Boolean,
            required: false,
            default: false,
        },
        reference: {
            type: String,
            required: false,
            default: 'roster',
        },
        classes: {
            type: [ String, Array ],
            required: false,
            default: 'form-control'
        },
        columnIds: {
            type: Array,
            required: false,
        },
        buttonNo: {
            default: true
        },

        buttonYes: {
            default: true
        },

        buttonNoLabel: {
            type: String,
            required: false,
        },

        buttonYesLabel: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            oasisV3Api: new Axios('/restv3'),
            currentOverride: undefined,
            loading: false, // spinner
            iteration: 0,
            localValueFormatter: function localValueFormatter(params) {
                var value = params.value;
                if (!value) return 'Non Union';
                return value;
            },
            generateIndividualStartFormModal: false,
            // searchQueryDateStart: undefined,
            // searchQueryDateEnd: undefined,
            locale: window.navigator.userLanguage || window.navigator.language || 'en-US', // 'fr-fr' // test stuff
            // oasisApi: new Axios('/restv2'),
            // oasisV3Api: new Axios('/restv3'),
            // link: '',
            showAssignmentOverrideBox: false,
            showModal: false,
            modalMessage: '',
            // usesSplitForms: false,
            // availableForms: {},
            // selectedForms: ref([]),

            // AG Grid
            rowData: [],
            sidebar: undefined,
            filterOrder: undefined,
            defaultColumnDefs: [
                'date_start', 'date_end', 'project', 'job_title_override', 'department', 'rate', 'rate_unit', 'status_full'
            ],
            gridOptions: {
                domLayout: 'autoHeight',
                singleClickEdit: false,
                undoRedoCellEditing: false,
                enterMovesDown: false,
                enterMovesDownAfterEdit: false,
                rowSelection: 'multiple',
                // select by clicking checkbox only
                suppressContextMenu: true,
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    menuTabs: [],
                    suppressSizeToFit: false,
                    headerCheckboxSelectionFilteredOnly: true,
                    floatingFilter: true,
                    filterParams: {
                        suppressMiniFilter: true,
                        defaultToNothingSelected: true,
                        buttons: ['reset', 'apply'],
                        debounceMs: 200
                    }
                },

                // Excel
                defaultExcelExportParams: {
                    onlySelected: true
                },
                onGridReady: (event) => this.$refs[this.reference].onGridReady(event),
                onCellClicked: (event) => {
                    // if clicked on first row, load the assignment
                    if ((event.column.getColId() === 'employee' || event.column.getColId() === 'job_title_override') && event && event.data && event.data.id) {
                        this.openAssignmentOverride(event.data)
                    }
                },
            },
            availableColumnDefs: [
                /*
    protected $name;
    protected $budget_code;
    protected $fringe_code;
    protected $union_ruleset_id;
    protected $union_schedule_id;
    protected $union_on_prod_id;
    protected $union_flsa_type_id;
    protected $scale_rate;
    protected $scale_stn;
    protected $employee_comments;
    protected $employer_comments;
    protected $status;
    protected $occ_code;
    protected $termination_comments;
    protected $termination_forms;
    protected $termination_form_fields;
    protected $rate_comment;
    protected $time_updated;
    protected $time_added;

    // Psuedo data from foreign keys
    protected $assignment;
    protected $location;
    protected $job_title;
    protected $project;
    protected $department;
    protected $rate_unit;
    protected $guaranteed_hours_unit;
    protected $rule_collection;
    protected $union_ruleset;
    protected $union_schedule;
    protected $union_on_prod;
    protected $union_flsa_type;
    */

                {
                    field: 'id',
                    colId: 'id',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    hide: true,
                    valueGetter: (params) => params.data.id,
                    menuTabs: [],
                },
                {
                    field: 'rate',
                    colId: 'rate',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.rate,
                    menuTabs: [],
                },
                {
                    field: 'rate_unit',
                    colId: 'rate_unit',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.rate_unit,
                    menuTabs: [],
                },
                {
                    field: 'hourly_rate',
                    colId: 'hourly_rate',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.hourly_rate,
                    menuTabs: [],
                },
                {
                    field: 'guaranteed_hours',
                    colId: 'guaranteed_hours',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.guaranteed_hours,
                    menuTabs: [],
                },
                {
                    field: 'guaranteed_hours_unit',
                    colId: 'guaranteed_hours_unit',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.guaranteed_hours_unit,
                    menuTabs: [],
                },
                {
                    field: 'rule_collection',
                    colId: 'rule_collection',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.rule_collection,
                    menuTabs: [],
                },
                {
                    field: 'status',
                    colId: 'status',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.status,
                    menuTabs: [],
                },
                {
                    field: 'custom_forms',
                    colId: 'custom_forms',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.custom_forms,
                    menuTabs: [],
                },
                {
                    field: 'custom_form_fields',
                    colId: 'custom_form_fields',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.custom_form_fields,
                    menuTabs: [],
                },
                {
                    field: 'custom_form_employer_fields',
                    colId: 'custom_form_employer_fields',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.custom_form_employer_fields,
                    menuTabs: [],
                },
                {
                    field: 'assignment_id',
                    colId: 'assignment_id',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.assignment_id,
                    menuTabs: [],
                },
                {
                    headerName: 'Employee',
                    field: 'employee',
                    colId: 'employee',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    maxWidth: 500,
                    minWidth: 300,
                    editable: false,
                    sortable: true,
                    comparator: this.caseInsensitiveComp,
                    filter: true,
                    cellRenderer: (params) => params.data.employee ? `<span class="fakelink">${params.data.employee}</span>` : '',
                    valueGetter: (params) => params.data.employee,
                    menuTabs: [],
                },
                {
                    headerName: 'Last Name',
                    field: 'last_name',
                    colId: 'last_name',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    maxWidth: 350,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    comparator: this.caseInsensitiveComp,
                    filter: true,
                    valueGetter: (params) => params.data.last_name,
                    menuTabs: [],
                },
                {
                    headerName: 'First Name',
                    field: 'first_name',
                    colId: 'first_name',
                    maxWidth: 300,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    comparator: this.caseInsensitiveComp,
                    filter: true,
                    valueGetter: (params) => params.data.first_name,
                    menuTabs: [],
                },
                {
                    headerName: 'Loanout',
                    field: 'loanout_name',
                    colId: 'loanout_name',
                    maxWidth: 300,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => parseInt(params.data.loanout_status) > 0 ? params.data.loanout_name : '',
                    menuTabs: [],
                },
                {
                    headerName: 'Position',
                    field: 'job_title_override',
                    colId: 'job_title_override',
                    maxWidth: 500,
                    minWidth: 250,
                    editable: false,
                    sortable: true,
                    filter: true,
                    cellRenderer: (params) => `<span class="fakelink">${params.data.job_title_override || this.assignment.job_title_override || ''}</span>`,
                    valueGetter: (params) => params.data.job_title_override,
                    menuTabs: [],
                },
                {
                    headerName: 'Department',
                    field: 'department',
                    colId: 'department',
                    maxWidth: 250,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    comparator: this.caseInsensitiveComp,
                    filter: true,
                    cellRenderer: (params) => params.data.department || this.assignment.department || '',
                    valueGetter: (params) => params.data.department,
                    menuTabs: [],
                },
                {
                    headerName: 'Local',
                    field: 'union_local',
                    colId: 'union_local',
                    maxWidth: 150,
                    minWidth: 70,
                    editable: false,
                    sortable: true,
                    filter: true,
                    filterParams: { valueFormatter: this.localValueFormatter },
                    valueGetter: (params) => params.data.union_local,
                    menuTabs: [],
                },
                {
                    headerName: 'Project',
                    field: 'project',
                    colId: 'project',
                    maxWidth: 400,
                    minWidth: 100,
                    width: 200,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.project,
                    menuTabs: [],
                },
                {
                    headerName: 'Member',
                    field: 'union_member',
                    colId: 'union_member',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    hide: true,
                    valueGetter: (params) => params.data.union_member,
                    menuTabs: [],
                },
                {
                    headerName: 'Hired From',
                    field: 'union_hired_from',
                    colId: 'union_hired_from',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.union_hired_from,
                    menuTabs: [],
                },
                {
                    headerName: 'Res State',
                    field: 'employee_state_code',
                    colId: 'employee_state_code',
                    maxWidth: 100,
                    minWidth: 50,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.employee_state_code,
                    menuTabs: [],
                },
                {
                    headerName: 'Account',
                    field: 'budget_code',
                    colId: 'budget_code',
                    maxWidth: 250,
                    minWidth: 70,
                    width: 70,
                    editable: false,
                    sortable: true,
                    comparator: this.caseInsensitiveComp,
                    filter: true,
                    valueGetter: (params) => params.data.budget_code,
                    menuTabs: [],
                },
                {
                    headerName: 'Fringe',
                    field: 'fringe_code',
                    colId: 'fringe_code',
                    maxWidth: 250,
                    minWidth: 70,
                    width: 70,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.fringe_code,
                    menuTabs: [],
                },
                {
                    headerName: 'Status',
                    field: 'status_full',
                    colId: 'status_full',
                    maxWidth: 200,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueGetter: (params) => params.data.status_full,
                    menuTabs: [],
                },
                {
                    headerName: 'Start',
                    field: 'date_start',
                    colId: 'date_start',
                    maxWidth: 100,
                    minWidth: 100,
                    width: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueFormatter: (params) => {
                        if (!params.value) return null;
                        try {
                            const date = new Date(params.value.replace(/-/g, '/'));
                            return date.toLocaleDateString('en-CA');
                        } catch (error) {
                            console.log('Check Date: ' + date, error);
                            return '';
                        }
                    },
                    valueGetter: (params) => params.data.date_start,
                    menuTabs: [],
                },
                {
                    headerName: 'End',
                    field: 'date_end',
                    colId: 'date_end',
                    maxWidth: 100,
                    minWidth: 100,
                    width: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueFormatter: (params) => {
                        if (!params.value) return null;
                        try {
                            const date = new Date(params.value.replace(/-/g, '/'));
                            return date.toLocaleDateString('en-CA');
                        } catch (error) {
                            console.log('Check Date: ' + date, error);
                            return '';
                        }
                    },
                    valueGetter: (params) => params.data.date_end,
                    menuTabs: [],
                },
                {
                    headerName: 'Email',
                    field: 'Email',
                    colId: 'Email',
                    maxWidth: 200,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    comparator: this.caseInsensitiveComp,
                    valueGetter: (params) => params.data.email,
                    menuTabs: [],
                },
                {
                    headerName: 'Phone',
                    field: 'phone',
                    colId: 'phone',
                    maxWidth: 200,
                    minWidth: 100,
                    editable: false,
                    sortable: true,
                    filter: true,
                    valueFormatter: (params) => {
                        if (!params.data || !params.data.phone) return
                        const phoneString = String(params.data.phone);
                        const phoneDigits = String(phoneString.replace(/\D/g, ''));
                        let result

                        if (phoneString.substring(0, 1) === '\+') {
                            result = phoneString;
                        } else if (phoneDigits.substring(0, 1) === '1' && phoneDigits.length === 11) {
                            result = `(${phoneDigits.substring(1, 4)}) ${phoneDigits.substring(4, 7)}-${phoneDigits.substring(7, 11)}`;
                        } else if (phoneDigits.length === 10) {
                            result = `(${phoneDigits.substring(0, 3)}) ${phoneDigits.substring(3, 6)}-${phoneDigits.substring(6, 10)}`;
                        } else {
                            result = phoneString;
                        }
                        return result;
                    },
                    valueGetter: (params) => params.data.phone,
                    menuTabs: [],
                },
            ],
        }
    },

    computed: {
        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.63 + 'px';
        },

        today() {
            let date = new Date();
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + this.pad(monthIndex * 1 + 1) + '-' + this.pad(day);
        },

        isTerminated() {
            if (!this.assignment) true;
            if (this.assignment.term_date) {
                const now = new Date();
                let termDateObject;
                try {
                    termDateObject = new Date(this.assignment.term_date);
                } catch (error) {
                    termDateObject = null;
                }
                if (termDateObject && now >= termDateObject) {
                    return true;
                }
            }
            return false;
        },

        // Build a list of useable ag-grid column definitions from available columns
        columnDefs() {
            // Look for colIds from props first, and if not, use the default
            const columnIds = this.columnIds || this.defaultColumnDefs;
            var result = [];
            for (const i in columnIds) {
                const id = columnIds[i];
                const columnDef = this.availableColumnDefs.find((def) => def.colId === id || def.name === id);
                if (columnDef) result.push(columnDef);
            }
            return result;
        }
    },

    watch: {
        assignment(newValue, oldValue) {
            if (newValue) this.getOverrides();
            this.iteration++;
        },
    },

    methods: {
        closeBox(event) {
            this.$emit('close');
        },

        createDialog(message) {
            this.modalMessage = message;
            this.showModal = true;
        },

        // Get employee overrides from the Rest V3 Employer/startOverrides endpoint
        async getOverrides() {
            if (!this.assignment || !this.assignment.id) return false;
            this.loading = true;
            const endpoint = `/employer/startOverrides/${this.assignment.id}`;
            let response;
            try {
                response = await this.oasisV3Api.get(endpoint);
            } catch (error) {
                console.error('Error fetching overrides:', error);
            }
            if (response && response.data && response.data.results) {
                this.rowData = response.data.results;
            } else {
                this.rowData = [];
            }

            this.loading = false;
        },

        getSelectedData() {
            if (!this.gridOptions) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []);
        },

        getSelectedHashes() {
            if (!this.gridOptions) return [];
            return ((this.gridOptions.api || {}).getSelectedRows() || []).map((row) => row.hash);
        },

        async openAssignmentOverride(override) {
            if (!override.id) {
                this.currentOverride = undefined;
                return false;
            }
            // window.open(`/oasis/starts/approve/${overrideId}`, '_roster');
            this.currentOverride = override;
            this.showAssignmentOverrideBox = true;
        },

        async addAssignmentOverride(event) {
            this.showAssignmentOverrideBox = true;
            this.currentOverride = undefined;
            if (!event || !event.data || !event.data.id) {
                return false;
            }

            // this.showAssignmentOverrideBox = true;
        },

        async saveAssignmentOverride(event) {
            if (!event || !event.id) {
                return false;
            }
            await this.getOverrides();
            this.iteration++;
            this.gridOptions.api.redrawRows()
            return true;
        },

        closeAssignmentOverrideBox() {
            // if (this.currentFilters) {
            //     this.gridOptions.api.setFilterModel(this.currentFilters);
            // }
            this.showAssignmentOverrideList = false;
            this.currentAssignment = undefined;
        },

        exportToExcel() {
            const hashes = this.gridOptions.api.getSelectedRows().map((row) => row.hash) || [];
            if (hashes.length === 0) {
                this.createDialog('Please Select at least one item to export.');
                return;
            }
            this.gridOptions.api.exportDataAsExcel();
        },


        caseInsensitiveComp(valueA, valueB) {
            const a = String(valueA);
            const b = String(valueB);
            return a.toLowerCase().localeCompare(b.toLowerCase());
        },
    },

    watch: {
    },

    created() {
        /*
        this.filterOrder = [
            { field: 'last_name' },
            { field: 'loanout_name' },
            { field: 'department' },
            { field: 'union_local' },
            { field: 'union_dues_withholding' },
            { field: 'job_title_override' },
            { field: 'budget_code' },
            { field: 'fringe_code' },
            { field: 'status_full' },
            { field: 'employee_state_code' },
        ];
        */
    },

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };

        // this.resetSearch();
        // this.getAvailableForms();
        // this.buildRowData();
        if (this.assignment && this.assignment.id) {
            await this.getOverrides();
        }
    }
});
</script>

<style>
.reviewBox {
    position: absolute;
    right: 100px;
    z-index: 1000;
    border: 2px solid red;
    border-radius: 10px;
    /* box-shadow: 2px 20px 40px 30px #666; */
    padding: 20px;
    background-color: white;
    min-width: 900px;
    max-width: 90%;
}
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4); /* Dimming effect */
    backdrop-filter: blur(5px);           /* Optional blur effect */
    z-index: 999;                         /* Sits on top of content */
}
.option {
    font-size: 1.1em;
    font-weight: bold;
    text-decoration: underline;
}
.info {
    font-weight: lighter;
}
</style>
